import React from "react";
import { Switch, Typography, Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
	root: {
		background: '#212121'
	},
	TypographyRoot: {
		color: 'white'
	},
	switchBase: {
		color: '#bdbdbd',
		'&$checked': {
			transform: 'translateX(16px)',
			color: '#4CAF50',
			'& + $track': {
				backgroundColor: '#3E8040',
				opacity: 1,
				border: 'none',
			},
		},
	},
	switchBase2: {
		color: '#bdbdbd',
		'&$checked': {
			transform: 'translateX(16px)',
			color: '#ffee58',
			'& + $track': {
				backgroundColor: '#B7A931',
				opacity: 1,
				border: 'none',
			},
		},
	},
	checked: {},
	track: {},
	swithColorPrimary: { color: 'yellow' }
});

export const SwitchIngreso = (props) => {
	const classes = useStyles();
	const {
		obligatorio,
		id,
		label,
		seleccionado,
		idTipoDocumentacionesSubtipoEfectores
	} = props;
	return (
		<Grid container>
			<Grid item xs={6}>
				<Grid container justify="center" alignItems="center">
					<Grid item xs={3}>
						<Switch
							checked={seleccionado}
							onChange={(event) => {
								if (event.target.checked) {
									props.handleCrear(id)
								} else {
									props.handleDelete(idTipoDocumentacionesSubtipoEfectores)
								}
							}}
							value={idTipoDocumentacionesSubtipoEfectores ? idTipoDocumentacionesSubtipoEfectores : ""}
							classes={{ switchBase: classes.switchBase, checked: classes.checked, track: classes.track }}
						/>
					</Grid>
					<Grid item xs={9}>
						<Typography className={classes.TypographyRoot}>{label}</Typography>
					</Grid>
				</Grid>
			</Grid>
			<Grid item xs={6}>
				<Grid container justify="center" alignItems="center">
					<Grid item xs={3}>
						<Switch
							checked={obligatorio}
							onChange={(event) => props.handleEditar(
								idTipoDocumentacionesSubtipoEfectores,
								event.target.checked
							)}
							classes={{ switchBase: classes.switchBase2, checked: classes.checked, track: classes.track }}
						/>
					</Grid>
					<Grid item xs={9}>
						<Typography className={classes.TypographyRoot}>Obligatorio</Typography>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};
